function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_material-business-center",
  "data-name": "Icon material-business-center",
  transform: "translate(1.5 1.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-business-center-2",
  "data-name": "Icon material-business-center",
  d: "M19.223,30.863V28.835H5.048l-.02,8.112A4.042,4.042,0,0,0,9.084,41H37.474a4.042,4.042,0,0,0,4.056-4.056V28.835h-14.2v2.028ZM39.5,12.612H31.37V8.556L27.315,4.5H19.2L15.147,8.556v4.056H7.056A4.068,4.068,0,0,0,3,16.667v6.084a4.042,4.042,0,0,0,4.056,4.056H19.223V22.751h8.112v4.056H39.5a4.068,4.068,0,0,0,4.056-4.056V16.667A4.068,4.068,0,0,0,39.5,12.612Zm-12.167,0H19.223V8.556h8.112Z",
  transform: "translate(-3 -4.5)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 3
}));

function SvgModalBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.558,
    height: 39.502,
    viewBox: "0 0 43.558 39.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBusiness);
export default __webpack_public_path__ + "static/media/modalBusiness.db7a4b6a60a6e2c117dcf83a5fb9823f.svg";
export { ForwardRef as ReactComponent };